import { Component, Input } from '@angular/core'
import {
  MbAbstractInformationTileComponent
} from '../mb-abstract-information-tile/mb-abstract-information-tile.component'
import { MbOrderDetailsInfoType } from '../../../../models'

@Component({
  selector: 'mb-orderdetails-information-tile',
  templateUrl: './mb-orderdetails-infotmation-tile.component.html',
  styleUrls: ['./mb-orderdetails-infotmation-tile.component.scss']
})
export class MbOrderdetailsInfotmationTileComponent extends MbAbstractInformationTileComponent {

  infoTypes = MbOrderDetailsInfoType
  @Input() type: MbOrderDetailsInfoType | undefined
}
